import {useEffect, useLayoutEffect, useMemo, useRef, useState} from "react";
import useWebViewBridge from "../../hooks/useWebViewBridge";
import styles from "./PilotAirdropPreReg.module.css";
import particles1 from "../../asset/image/pilot/particles1.png";
import particles2 from "../../asset/image/pilot/particles2.png";
import {useMediaQuery} from "react-responsive";
import {useTranslation} from "react-i18next";
import logo from "../../asset/logo/perplay_logo_white.png";
import {SERVER_API_URL} from "../../config/config";
import refreshIcon from "asset/icon/ic_refresh.svg"
import {perLogger} from "../../utils/per-logger";
import {Box, Modal} from "@mui/material";
import closeIconBlack from "asset/icon/ic_close_black_24dp.svg"
import closeIconWhite from "asset/icon/ic_close_white_24dp.svg"
import {isMobile} from "react-device-detect";

const PilotAirdropPreReg = (props) => {

  const { data } = props;
  const [conditionNo, setConditionNo] = useState(null);

  useEffect(() => {
    if(data?.conditionNo){
      const parsedConditionNo = Number(data?.conditionNo);
      setConditionNo(parsedConditionNo);
    }
  }, [data])


  const isSmallWidth = useMediaQuery({ maxWidth: 1200 });
  const API_LOAD_USER_DATA = `/api/Common/CheckCollect`;
  const API_POST_WALLET_ADDRESS = `/api/Common/LogCollect`;

  const {
    authData,
    isAuthenticated,
    sendMessage,
    requestTokenRefresh,
    fetchWithTokenRefresh,
    getQueryParam
  } = useWebViewBridge();

  // 언어 설정
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    const langParam = getQueryParam('lang');

    if(langParam){
      changeLanguage(langParam);
    }

  }, []);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang)
        .then(() => {
          setLanguage(lang);
        })
        .catch((err) => {
          console.log(err);
          setLanguage("en");
        })
  }

  // 지갑 검증
  const [walletAddress, setWalletAddress] = useState("");
  const [isCorrectAddress, setIsCorrectAddress] = useState(true);
  const walletRegex = /^0x[a-fA-F0-9]{40}$/;

  const handleWalletAddressChange = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const address = e.target.value.trim();

    // setUserData((prev) => (
    //     {...prev,
    //       walletAddress : address
    //     }
    // ));

    setWalletAddress(address);

    if(!address){
      setIsCorrectAddress(true);
      return;
    }

    const isCorrect = walletRegex.test(address);
    setIsCorrectAddress(isCorrect);
  }

  // 유저 정보
  const [userData, setUserData] = useState({
    nickname: '',
    walletAddress: '',
    ticketId: 0,
    ticketAmount: 0,
  });

  // userData가 변경될 때마다 재계산됩니다
  const getUserData = useMemo(() => {
    return {
      ...userData,
      // 필요한 경우 가공 로직 추가
      hasWallet: Boolean(userData.walletAddress),
      hasTickets: userData.ticketAmount > 0,
      isLoaded : Boolean(userData.nickname),
    };
  }, [userData]);

  useEffect(() => {
    console.log(authData.jwt);
  }, [authData.jwt])


  // 유저 정보 fetch 성공 여부(인증 실패 메시지 출력하기 위함)
  const [isFetchSuccess, setIsFetchSuccess] = useState(true);
  // 이미 등록되었는지 여부(등록 완료 메시지 출력하기 위함)
  const [isRegistered, setIsRegistered] = useState(false);

  // 유저 정보 불러오는 함수
  const loadUserProfile = async () => {
    console.log("인증 요청");

    if(!conditionNo){
      return;
    }

    setIsFetchSuccess(true);

    if (!isAuthenticated) {
      // 인증되지 않은 경우(토큰이 존재하지 않음) 인증 요청
      sendMessage('AUTHORIZATION_REQUEST', {});
      setIsFetchSuccess(false);
      return;
    }

    try {
      // 유저 정보 요청
      const responseData = await fetchWithTokenRefresh(
          `${SERVER_API_URL}${API_LOAD_USER_DATA}`,
          {conditionNo: conditionNo},
          {timeout : 10000,}
      );
      console.log("responseData", responseData);

      const data = responseData?.checkCollectData;
      console.log("data", data);

      if(!data.nickName){
        setIsFetchSuccess(false);
        return;
      }

      setUserData((prev) => ({
        ...prev,
        nickname : data?.nickName,
        ticketAmount: data?.itemCount,
        walletAddress: data?.collectionItem,
      }));

      setIsFetchSuccess(true);

      // 이미 등록되어 있으면
      if(responseData.code === "208"){
        // console.log("이미 등록된 유저입니다.");
        // setModalMessage("이미 등록된 유저입니다.");
        // setIsModalOpen(true);
        setIsRegistered(true);
      }


    } catch (error) {
      perLogger.log(error, {ignore: ['prod'], consoleMode: true});
      console.error(error);
      setIsFetchSuccess(false);

      // 타임아웃 에러 처리
      if (error.code ==='ECONNABORTED' || error?.code === 408) {
        // alert 웹뷰에서 어떻게 처리하지...?
        // alert("요청이 만료되었습니다.");
        setModalMessage(t("USER_DATA_FETCH_FAIL"));
        setIsModalOpen(true);
      }

    }
  };

  // 유저 정보 초기 로드
  useEffect(() => {
    loadUserProfile();
  }, [isAuthenticated, conditionNo]);

  const [isSubmitting , setIsSubmitting] = useState(false);
  // 브라우저가 이미 상호작용 중인 요소의 상태를 유지하도록 하는 문제
  // input을 disabled 처리해도 이미 상호작용 중이기 때문에 수정되는 있음
  // 강제로 blur()해서 해결
  const inputRef = useRef(null);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (isDisabled && inputRef.current) {
      inputRef.current.blur(); // 포커스 제거
    }
  }, [isDisabled]);

  // 입력하기 버튼 클릭(지갑 주소 등록)
  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.blur();

    setIsSubmitting(true);

    if(!walletAddress){
      setModalMessage(t("WALLET_ADDRESS_NOT_ENTERED"));
      setIsModalOpen(true);
      setIsSubmitting(false);
      return;
    }

    if(!walletRegex.test(walletAddress)){
      setModalMessage(t("WALLET_ADDRESS_INCORRECT"));
      setIsModalOpen(true);
      setIsSubmitting(false);
      return;
    }

    try {
      // 유저 지갑 정보 전송
      const responseData = await fetchWithTokenRefresh(
          `${SERVER_API_URL}${API_POST_WALLET_ADDRESS}`,
          {
            conditionNo: conditionNo,
            collectionItem : walletAddress
          },
          {timeout : 10000}
      );

      // 중복 시
      if(responseData.code === "208"){
        perLogger.log("이미 등록된 지갑 주소입니다.", {ignore: ['prod'], consoleMode: true});
        // console.log("이미 등록된 지갑 주소입니다.");
        setModalMessage(t("WALLET_ADDRESS_ALREADY_REGISTRATION"));
        setIsModalOpen(true);
        setWalletAddress("");
        // setUserData((prev) => ({
        //   ...prev,
        //   walletAddress: ""
        // }))
      }

      setIsRegistered(true);
      setIsDisabled(true);

    } catch (error){
      perLogger.log(error, {ignore: ['prod'], consoleMode: true});
      console.error(error.message);

      // 타임아웃 에러 처리
      if (error.code ==='ECONNABORTED' || error?.code === 408) {
        // alert("요청이 만료되었습니다.");
        setModalMessage(t("WALLET_ADDRESS_REGISTRATION_FAIL"));
        setIsModalOpen(true);
      }

    } finally {
      setIsSubmitting(false);
    }
  }

  const retryLimit = 3;
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    console.log("retryCount: ", retryCount);
  }, [retryCount]);

  // 재시도 요청 버튼 클릭
  const handleClickRetryBtn = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if(retryCount >= retryLimit) {
      return;
    }

    // 유저 정보 재요청
    loadUserProfile()
        .then((res) => {
          // 카운트 증가
          setRetryCount((prev) => prev + 1);
        })
        .catch((error) => {
          console.error(error);
          setIsFetchSuccess(false);
        })

  }

  // notice 컴포넌트(하단 안내 문구)
  const StatusMessage = () => {

    // 인증이 안됐으면
    if (!isAuthenticated) {
      return t("WAITING_FOR_AUTH");
    }

    // 이미 지갑 주소가 등록되었다면
    if (isRegistered) {
      return t("WALLET_ADDRESS_REGISTRATION")
    }

    // 유저 정보가 존재하지만, 티켓이 없으면
    if (getUserData.isLoaded && !getUserData.hasTickets) {
      return t("NO_RECEIVE_NFT")
    }

    return null;
  };



  // 키보드 활성화 시 뷰포트 작아지는 문제 대응
  // 화면 높이
  const [height, setHeight] = useState(document.body.clientHeight);
  //
  const dimmedRef = useRef(null);

  // 화면 크기 변경 감지
  useEffect(() => {
    const handleResize = () => {
      setHeight(document.body.clientHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      dimmedRef.current.style.visibility = "hidden";
    }, 1000)
  }, []);

  // 키보드 활성화 시 뷰포트가 600 미만이 되면 dimmed visible
  useLayoutEffect(() => {

    if(!isMobile){
      return;
    }

    if (dimmedRef.current) {
      if (height <= 600) {
        dimmedRef.current.style.visibility = "visible";
      } else {
        dimmedRef.current.style.visibility = "hidden";
      }
    }
  }, [height]);

  // 모달
  const [modalMessage, setModalMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
      <>

        <header className={"header"}>
          <a className="header-logo" href={"https://perplay.io"}>
            <img src={logo} alt="perplay"/>
          </a>

          <div className={"lang-btn-container"}>
            <button
                type="button"
                className={language.includes("en")  ? "active" : ""}
                onClick={() => {changeLanguage("en")}}
            >
              EN
            </button>
            <div className={"separate-line"} />
            <button
                type="button"
                className={language.includes("ko") ? "active" : ""}
                onClick={() => {changeLanguage("ko")}}
            >
              KO
            </button>

          </div>
        </header>


        <section className={styles["airdrop-pre-register"]}>
          <article className={styles["title-container"]}>
            <div className={styles["title1"]}>
              PILOT
            </div>

            <div className={styles["title2"]}>
              AIRDROP
            </div>


            <div className={styles["desc"]}>
              {
                t("PRE_WALLET_ADDRESS_COLLECT")
              }
            </div>
          </article>

          <article className={styles["info-container"]}>

            <div className={styles["nickname-container"]}
                 style={{
                   display : isAuthenticated && getUserData.isLoaded ? "block" : "none",
                 }}
            >

              <div className={styles["title"]}>
                {
                  t("MY_PERPLAY_NICKNAME")
                }
              </div>

              <div className={styles["nickname"]}>
                {getUserData.nickname}
              </div>
            </div>

            <div className={styles["ticket-amount"]}
                 style={{
                   display : getUserData.isLoaded ? "flex" : "none",
                 }}
            >
              <div>
                {t("AIRDROP_AMOUNT")}
              </div>
              <div className={styles["separator"]}/>
              <strong>{getUserData.ticketAmount}</strong>
            </div>

            <div className={styles["waiting"]}
                style={{
                  display : getUserData.isLoaded ? "none" : "block",
                }}
            >
              {
                isFetchSuccess ?
                    <>{t("WAITING")}<LoadingDots/></>
                    : t("USER_DATA_FETCH_FAIL")
              }
            </div>

            {/* 재시도 버튼 */}
            {
              !isFetchSuccess && retryCount < retryLimit &&
                  <div className={styles["ticket-amount"]}
                       style={{display : "flex", alignItems: "center", gap: 10, cursor: "pointer", zIndex: 999}}
                       onClick={handleClickRetryBtn}
                  >
                    <img src={refreshIcon} alt="" style={{width: 20}}/>
                    {t("RETRY")}
                  </div>
            }

          </article>


          <article className={styles["particles"]}>
            {
              isSmallWidth ?
                  <img src={particles2} alt="" loading="lazy" />
                  : <img src={particles1} alt="" loading="lazy" />
            }
          </article>


          <article className={styles["bottom-glow-container"]}>
            <div className={styles["glow1"]}/>
            <div className={styles["glow2"]}/>
            <div className={styles["glow3"]}/>
          </article>

          <article
            ref={dimmedRef}
            className={`dimmed ${styles["dimmed"]}`}>
          </article>

          <article className={styles["input-container"]}>
            <div className={styles["desc"]}
                 style={{
                   display : getUserData.isLoaded ? "flex" : "none",
                 }}
            >
              {t("AIRDROP_START_NOTICE")}
            </div>


            <div className={styles["wallet-address-input-container"]}
                 style={{
                   display : getUserData.isLoaded ? "flex" : "none",
                 }}
            >
              <div
                  className={styles["wallet-address-input-wrapper"]}
                  // style={{
                  //   display : !isRegistered && getUserData.hasTickets ? "block" : "none",
                  // }}
                  style={{
                    display : getUserData.walletAddress || getUserData.hasTickets ? "block" : "none",
                  }}
              >
                <input type="text"
                       ref={inputRef}
                       name={"wallet-address"}
                       className={styles["wallet-address-input"]}
                       placeholder={t("WALLET_ADDRESS_INPUT")}
                       pattern={"^0x[a-fA-F0-9]{40}$"}
                       value={getUserData.walletAddress || walletAddress}
                       disabled={getUserData.walletAddress || isDisabled}
                       onChange={handleWalletAddressChange}
                />
                {/*{*/}
                {/*  userData.walletAddress &&*/}
                {/*    <div className={styles["wallet-address-reset-btn"]}*/}
                {/*         onClick={() => {setUserData((prev) => (*/}
                {/*             {*/}
                {/*               ...prev,*/}
                {/*               walletAddress: ""*/}
                {/*             }*/}
                {/*         ))}*/}
                {/*         }*/}
                {/*    >*/}
                {/*      <img src={closeIconWhite} alt=""/>*/}
                {/*    </div>*/}
                {/*}*/}

              </div>

              <button type="button"
                      disabled={!isCorrectAddress}
                      className={`
                                    ${styles[!isCorrectAddress ? "wrong-address" : ""]} 
                                    ${walletAddress && isCorrectAddress ? styles.active : ""} 
                                `}
                      onClick={handleSubmit}
                      style={{
                        display : !isRegistered && getUserData.hasTickets ? "block" : "none",
                      }}
              >
                {
                  isCorrectAddress ?
                      isSubmitting ?
                          <>{t("SUBMITTING")}<LoadingDots/></>
                          : t("WALLET_ADDRESS_ENTER")
                      : t("WALLET_ADDRESS_INCORRECT")
                }
              </button>

              <div className={styles["notice"]}
                   style={{
                     paddingBottom : !isRegistered && getUserData.hasTickets ? "0" : "5vh",
                   }}
              >
                <StatusMessage />
              </div>
            </div>




          </article>
        </section>


        <Modal
            className={styles["pilot-airdrop-modal"]}
            open={isModalOpen}
            onClose={() => {setIsModalOpen(false)}}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
          <Box className={styles["inner-container"]}>
            <div className={styles["modal-title"]}>
              <div className={styles["modal-title-text"]}>
                <strong>
                  PILOT AIRDROP
                </strong>
              </div>
              <button
                  type="button"
                  onClick={() => {setIsModalOpen(false)}}
              >
                <img src={closeIconBlack} alt=""/>
              </button>
            </div>

            <div className={styles["modal-content"]}>
              {modalMessage}
            </div>

            <button
                type="button"
                className={styles["modal-close-btn"]}
                onClick={() => {setIsModalOpen(false)}}
            >
              {t("CLOSE")}
            </button>
          </Box>
        </Modal>


      </>
  )

}

export default PilotAirdropPreReg;



// 점 컴포넌트...
const LoadingDots = () => {
  const [dots, setDots] = useState('.');

  useEffect(() => {
    const dotSequence = [ '.', '..', '...',];
    let index = 0;

    const intervalId = setInterval(() => {
      setDots(dotSequence[index]);
      index = (index + 1) % dotSequence.length;
    }, 500);

    return () => clearInterval(intervalId);
  }, []);

  return <span>{dots}</span>;
};




